export default __webpack_public_path__ + "static/media/Цинк_40л.141f27d4.jpg";